import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { useState } from "react";
import { Col } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../entities/helper/IConfirmacionMantenedor";
import ILogMantenedor, { IDesactivarRegistro } from "../../../entities/ILogMantenedor";
import { shortDate } from "../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { getAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../helpers/userHelper";
import { API_ADMIN_LOG_MANTENEDOR, ROW_COUNT, URL_SUPPORT } from "../../../helpers/variableHelper";
import AdminLista from "../AdminLista";
import Select from "react-select";
import { IComboboxOption } from "../../../entities/helper/IComboboxOption";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import DesviacionService from "../../../services/DesviacionService";
import LIOService from "../../../services/LIOService";
import AuditoriaService from "../../../services/AuditoriaService";
import { cParamsPageSize } from "../../../helpers/paramsHelper";
import ProveedorService from "../../../services/ProveedorService";
import moment from "moment";
import { mantenedorDesv } from "../../../test/variableTest";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import Loading from "../../../cross/Loading";
const MySwal = withReactContent(Swal);
interface IMantenedorRegistrosDesactivadosProps {
  items?: Array<any>;
  ItemsConfirmacion?: Array<IConfirmacionMantenedor>;
  is_Test?: boolean;
}

const RenderAcciones = (info: any, handleActivarRegistros: any, currentUser: any, handleBuscar: any, handleDeleteRegistros: any) => {
  return (
    <div>
      <i
        className="bi bi-eye me-3 btnIconoInactive fs-6"
        title="Activar"
        role="button"
        onClick={() => {
          MySwal.fire({
            html: (
              <div>
                <h3>
                  ¿Desea activar el registro con {info.row.original.CORRELATIVO} de la tabla {info.row.original.TABLA}?
                </h3>
              </div>
            ),
            text: "",
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              MySwal.fire({
                html: (
                  <div>
                    <h4>Ingrese un Motivo:</h4>
                  </div>
                ),
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: '<i class="bi bi-eye"></i>Activar',
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async (txtMotivo) => {
                  if (!txtMotivo) {
                    Swal.showValidationMessage(`Debe ingresar un motivo`);
                  } else {
                    await handleActivarRegistros({
                      ...info.row.original,
                      EDITOR: currentUser?.email as string,
                      EDITOR_DISPLAY: currentUser?.fullname as string,
                      MOTIVO: txtMotivo,
                      DESACTIVAR: false,
                      FECHA_MODIFICACION: moment().toDate(),
                      ACCION: "ACTIVAR",
                      VALOR_INICIAL: "N/A",
                      VALOR_FINAL: "N/A",
                      CAMPO: "N/A",
                    });
                    await handleBuscar();
                  }
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                if (result.isConfirmed) {
                  console.log("");
                }
              });
            }
          });
        }}></i>
      <i
        className="bi bi-trash btnIconoActive fs-6"
        title="Eliminar"
        role="button"
        onClick={() => {
          MySwal.fire({
            html: (
              <div>
                <h3>
                  ¿Desea eliminar el registro {info.row.original.CORRELATIVO} de la tabla {info.row.original.TABLA}?
                </h3>
                <p className="alert alert-danger bg-danger text-white text-center">
                  <strong>Al eliminar un registro además se eliminará todo el contenido asociado y no podrán ser recuperado</strong>
                </p>
              </div>
            ),
            text: "",
            icon: "warning",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#dc3545",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              MySwal.fire({
                html: (
                  <div>
                    <h4>Ingrese un Motivo:</h4>
                  </div>
                ),
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: '<i class="bi bi-exclamation-triangle"></i>Eliminar',
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#dc3545",
                showLoaderOnConfirm: true,
                preConfirm: async (txtMotivo) => {
                  if (!txtMotivo) {
                    Swal.showValidationMessage(`Debe ingresar un motivo`);
                  } else {
                    await handleDeleteRegistros({
                      ...info.row.original,
                      EDITOR: currentUser?.email as string,
                      EDITOR_DISPLAY: currentUser?.fullname as string,
                      MOTIVO: txtMotivo,
                      DESACTIVAR: false,
                      FECHA_MODIFICACION: new Date(),
                      ACCION: "ELIMINAR",
                      VALOR_INICIAL: "N/A",
                      VALOR_FINAL: "N/A",
                      CAMPO: "N/A",
                    });
                  }
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await handleBuscar();
                }
              });
            }
          });
        }}></i>
    </div>
  );
};

export default function MantenedorRegistrosDesactivados({ items, ItemsConfirmacion, is_Test = false }: IMantenedorRegistrosDesactivadosProps) {
  const userInfo = cognitoUserToken();

  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [token, setToken] = useState("");

  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);

  const [pageSize, setPageSize] = useState(ROW_COUNT);

  const [refComboModulo, setValComboModulo] = useState<IComboboxOption | null>(null);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const columnHelperHistoricoCambios = createColumnHelper<IDesactivarRegistro>();
  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);

    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    try {
      let params = cParamsPageSize(pageSize);
      getAPI(`${URL_SUPPORT}${API_ADMIN_LOG_MANTENEDOR}/GetAllRegistrosDesactivados`, { Authorization: `Bearer ${token}` }, params)
        .then((result) => {
          setListItems(result.result.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    } catch (e) {
      console.log(e);
    }
  }, []);

  const handleDeleteRegistros = async (log: IDesactivarRegistro) => {
    if (log.MODULO === "DESVIACIONES") {
      if (log.TABLA === "DESVIACIONES") {
        await DesviacionService.eliminarRegistroDesviacion(token, log);
      } else {
        await DesviacionService.eliminarCausaRegistroDesviacion(token, log);
      }
    } else if (log.MODULO === "LIOS") {
      if (log.TABLA === "LIO_INSPECCION_OBSERVACION") {
        await LIOService.eliminarRegistroLIO(token, log);
      } else {
        await LIOService.eliminarRegistroLIOAspecto(token, log);
      }
    } else if (log.MODULO === "AUDITORIA") {
      if (log.TABLA === "AUDITORIA") {
        await AuditoriaService.eliminarRegistroAuditoria(token, log);
      } else {
        await AuditoriaService.eliminarRegistroAuditoriaIN(token, log);
      }
    } else if (log.MODULO === "PROVEEDORES-PROGR.ANUALES") {
      await ProveedorService.eliminarRegistroProgramaAnual(token, log);
    } else if (log.MODULO === "PROVEEDORES") {
      await ProveedorService.eliminarRegistroPlanificaciones(token, log);
    } else if (log.MODULO === "PROVEEDORES-MEDIDAS") {
      await ProveedorService.eliminarRegistroMedida(token, log);
    }
    filter(undefined);
  };

  const handleActivarRegistros = async (log: IDesactivarRegistro) => {
    if (log.MODULO === "DESVIACIONES") {
      if (log.TABLA === "DESVIACIONES") {
        await DesviacionService.desactivarRegistro(token, log);
      } else {
        await DesviacionService.desactivarCausaRegistro(token, log);
      }
    } else if (log.MODULO === "LIOS") {
      if (log.TABLA === "LIO_INSPECCION_OBSERVACION") {
        await LIOService.desactivarRegistroLIO(token, log);
      } else {
        await LIOService.desactivarRegistroLIOAspecto(token, log);
      }
    } else if (log.MODULO === "AUDITORIA") {
      if (log.TABLA === "AUDITORIA") {
        await AuditoriaService.desactivarRegistroAuditoria(token, log);
      } else {
        await AuditoriaService.desactivarRegistroAuditoriaIN(token, log);
      }
    } else if (log.MODULO === "PROVEEDORES-PROGR.ANUALES") {
      await ProveedorService.desactivarRegistroProgramaAnual(token, log);
    } else if (log.MODULO === "PROVEEDORES") {
      await ProveedorService.desactivarRegistroPlanificacion(token, log);
    } else if (log.MODULO === "PROVEEDORES-MEDIDAS") {
      await ProveedorService.desactivarRegistroMedida(token, log);
    }
    filter(undefined);
  };

  let columnsDef = [
    columnHelperHistoricoCambios.accessor((row) => row.MODULO, {
      id: "MODULO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Módulo"),
      hide: false,
      title: "Módulo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.TABLA, {
      id: "TABLA",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Tabla"),
      hide: false,
      title: "Tabla",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.ID_REGISTRO, {
      id: "ID_REGISTRO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("ID Registro"),
      hide: false,
      title: "ID Registro",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      hide: false,
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IDesactivarRegistro, number>) =>
        RenderAcciones(
          info,
          (info: any) => {
            handleActivarRegistros(info);
          },
          currentUser,
          handleBuscar,
          (info: any) => {
            handleDeleteRegistros(info);
          }
        ),
      header: () => component("Acciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.MOTIVO, {
      id: "MOTIVO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Motivo"),
      hide: false,
      title: "Motivo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.AUTOR_DISPLAY, {
      id: "AUTOR",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Autor"),
      hide: false,
      title: "Autor",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => shortDate(row.FECHA_CREACION as Date), {
      id: "FECHA_CREACION",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Fecha Acción"),
      hide: false,
      tipo: ITipo_Campo.date,
      className: "colorGris",
    } as any),
  ] as any;

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };

  const filter = (filter: any, page: boolean = false, size = pageSize) => {
    setIsLoading(true);
    if (!filter) {
      filter = {};
    }

    filter.TIPO_FACTOR = filter.ID_TIPO_FACTOR?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = 1;
    }
    if (!page) {
      filter.PAGINA = 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }

    const valModulo = refComboModulo?.value;
    if (valModulo !== undefined) {
      filter.MODULO = valModulo;
    }

    getAPI(`${URL_SUPPORT}${API_ADMIN_LOG_MANTENEDOR}/GetAllRegistrosDesactivados`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setListItems(result.result.data);
        setIsLoading(false);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const edit = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  const handleBuscar = async () => {
    const valModulo = refComboModulo?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      MODULO: valModulo,
    };

    let result = is_Test
      ? { data: items, pages: 0 }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_LOG_MANTENEDOR}/GetAllRegistrosDesactivados`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result != null ? result.data : [];
    setListItems(list);
    let pages = result != null ? result.pages : 0;
    setPages(pages);
  };

  return (
    <section>
      <div className="row">
        <button
          hidden={true}
          data-testid="btnpaging"
          onClick={() => {
            paging(1);
          }}></button>
        <button
          hidden={true}
          data-testid="btnedit"
          onClick={() => {
            edit({ AUTOR: "", AUTOR_DISPLAY: "", EDITOR: "", EDITOR_DISPLAY: "", ID: "" }, {});
          }}></button>
        <button
          hidden={true}
          data-testid="btndelete1"
          onClick={() => {
            handleActivarRegistros(mantenedorDesv);
            handleDeleteRegistros(mantenedorDesv);
          }}></button>
        <button
          hidden={true}
          data-testid="btndelete2"
          onClick={() => {
            let m = mantenedorDesv;
            m.MODULO = "AUDITORIA";
            m.TABLA = "AUDITORIA";
            handleActivarRegistros(m);
            handleDeleteRegistros(mantenedorDesv);
          }}></button>
        <button
          hidden={true}
          data-testid="btndelete3"
          onClick={() => {
            let m = mantenedorDesv;
            m.MODULO = "LIOS";
            m.TABLA = "LIO_INSPECCION_OBSERVACION";
            handleActivarRegistros(m);
            handleDeleteRegistros(mantenedorDesv);
          }}></button>
        <button
          hidden={true}
          data-testid="btndelete4"
          onClick={() => {
            let m = mantenedorDesv;
            m.MODULO = "PROVEEDORES-PROGR.ANUALES";
            m.TABLA = "PLANIFICACION";
            handleActivarRegistros(m);
            handleDeleteRegistros(mantenedorDesv);
          }}></button>
        <button
          hidden={true}
          data-testid="btndelete5"
          onClick={() => {
            let m = mantenedorDesv;
            m.MODULO = "PROVEEDORES";
            m.TABLA = "PLANIFICACION";
            handleActivarRegistros(m);
            handleDeleteRegistros(mantenedorDesv);
          }}></button>
        <button
          hidden={true}
          data-testid="btndelete6"
          onClick={() => {
            let m = mantenedorDesv;
            m.MODULO = "PROVEEDORES-MEDIDAS";
            m.TABLA = "PLANIFICACION";
            handleActivarRegistros(m);
            handleDeleteRegistros(mantenedorDesv);
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Registros Desactivados</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Nota:</strong> Nota: La siguiente tabla presenta una visión completa de todas las registros desactivados a través de la
                  herramienta de mantenimiento de cada módulo.
                </small>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Módulo:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboModulo || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={[
                      { value: "DESVIACIONES", label: "DESVIACIONES" },
                      { value: "LIOS", label: "LIOS" },
                      { value: "AUDITORÍA", label: "AUDITORÍA" },
                      { value: "PROVEEDORES", label: "PROVEEDORES" },
                    ]}
                    onChange={async (e: any) => {
                      setValComboModulo(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={async () => {
                      handleBuscar();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      setValComboModulo(null);
                      setListItems([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        {isLoading && <Loading />}
        <AdminLista
          reload={filter}
          items={[]}
          callback={edit}
          data={listItems}
          tipo={"MantenedorDesviaciones"}
          filter={filter}
          pagination={{ pages: pages, page: page, paging: paging }}
          title=""
          hideAdd={true}
          hideExport={true}
          columnsDef={columnsDef}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filter(filters, false, pageSize);
          }}
        />
      </div>
    </section>
  );
}
